<template>
	<div>
        <dialogue
        :title="'Success'"
        :paragraph="save_dialogue_text"
        :button_names="['Accept']"
        :show="save_dialogue"
        :autoClose="false"
        v-on:dialogue="saveDialogue"
        v-on:cancel="saveDialogueCancel"
        ></dialogue>

		<dialogue
		:title="'Resolve Troubleticket'"
		:paragraph="resolve_dialogue_text"
		:button_names="['Accept','Download Files']"
		:show="resolve_dialogue"
		:autoClose="false"
		:html="resolve_html"
		v-on:dialogue="resolveDialogue"
		v-on:cancel="resolveDialogueCancel"
		></dialogue>

		<div class="box">
	        <div class="field">
	            <p class="title">Submit Troubleticket</p>
	        </div>

	        <hr style="margin-left:25px;margin-right:25px;"/>

	        <table>
				<tr>
				   <td style="width:100%" colspan="2">
					   <b>Summary</b>
				   </td>
			   	</tr>
	            <tr>
					<td style="width:100%" colspan="2">
	                    <textarea class="textfield" v-model="issue" placeholder="write issue here"></textarea>
	                </td>
	            </tr>
				<tr>
				   <td style="width:100%" colspan="2">
					   <b>System</b>
				   </td>
			   	</tr>
	            <tr>
					<td style="width:100%" colspan="2">
	                    <input style="width:100%;" v-model="system"></input>
	                </td>
	            </tr>
				<tr>
				   <td style="width:100%" colspan="2">
					   <b>Related Files</b>
				   </td>
			   	</tr>
	        </table>

			<b-form-file
				class="upload-box text-nowrap text-truncate"
				v-bind:class="{ unselectable: save_dialogue||resolve_dialogue }"
				size="lg"
				v-model="uploadFiles"
				:state="Boolean(uploadFiles)"
				placeholder="Choose or Drop files here"
				drop-placeholder="Drop files here"
				@input="select()"
				multiple
				:disabled="save_dialogue||resolve_dialogue"
			></b-form-file>

			<hr style="margin-left:25px;margin-right:25px;"/>

			<div class="field">
				<button type="button" v-on:click="save()">Submit</button>
			</div>
			<div class="uploading-box" v-bind:class="{ hidden: !loading }" style="margin-bottom:10px">
				<div v-bind:id="'loading-progress'" class="uploading-bar-green" v-bind:style="'width:'+loadingBarWidth+'%'"></div>
			</div>
			<div class="uploading-box" v-bind:class="{ hidden: !uploading }" style="margin-bottom:10px">
				<div v-bind:id="'progress'" class="uploading-bar">
					<p v-bind:id="'progress-text'" class="upload-text"></p>
				</div>
			</div>
	    </div>

		<layout-1
		v-if="perms.includes('101')"
		:table_name="'Troubletickets'"
		:id=pageid
		:searchbar=true
		:collapseable="true"
		:navbar=false
		:term=term
		:key=updateKey
		:button_perm="'101'"
		:button_name="'Edit'"
		v-on:select="resolveIssue"
		style="width:100%; height:calc(100vh - 690px);"
		></layout-1>

	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid:PAGES.ADD_ISSUES_PAGE,
			pageid2:PAGES.ADD_ISSUES_PICTURE_PAGE,
			pageid3:PAGES.RESOLVE_ISSUE_PAGE,
			issue:'',
			system:'Web App',

			save_dialogue:false,
			save_dialogue_text:'',

			resolve_dialogue:false,
			resolve_dialogue_text:'',
			resolve_html:'',
			resolve_html_placeholder:'<textarea id="summaryText" style="width:100%;">\{{0}}</textarea> <input id="resolveText" style="width:100%;" \{{1}}></input>',
			resolve_value:0,

			updateKey:0,

			uploadFiles:[],
			files:[],
			uploading:false,
			loading:false,
			ready:false,
			progressBar:null,
			loadingBar:null,
			loadingBarWidth:0,
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	methods:{
		save (){
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid,
						data:[
							this.issue,
							this.system,
						],
					}
				}
			).then((res) => {

				let issueId = res.data.issueId;

				this.uploading=true;
				this.ready=false;
				this.progressBar.style = "width:0%"
				var fileCount = this.files.length

				api.postDataImage(
					{
						data:{
							pageid:this.pageid2,
							files:this.files,
							data:[
								issueId,
							]
						}
					},
					this.progressBar
				).then((res) => {
					this.uploadFiles = []
					this.files = []
				}).finally((res) => {
					this.uploading=false;
					this.loading=false;
					this.ready=false;

					this.save_dialogue_text = "Troubleticket submitted:\n"+this.issue
					this.save_dialogue = true
					this.updateKey++;
					this.issue = "";
				})
			});
        },
		saveDialogueCancel(){
			this.save_dialogue = false
		},
		saveDialogue(buttonname){
			if(buttonname == 'Accept'){
				this.saveDialogueCancel()
			}
		},

		resolveIssue(value){
			this.resolve_value = value[0]
			this.resolve_dialogue_text = "Resolve troubleticket "+value[0]+":"
			this.resolve_html = this.resolve_html_placeholder
			this.resolve_html = this.resolve_html.replace("\{{0}}", value[3])
			this.resolve_html = this.resolve_html.replace("\{{1}}", "value='"+value[5]+"'")

			this.resolve_dialogue = true
		},
		resolveDialogueCancel(){
			this.resolve_dialogue = false
		},
		resolveDialogue(buttonname){
			if(buttonname == 'Accept'){
				var resolveText = document.getElementById("resolveText").value
				var summaryText = document.getElementById("summaryText").value

				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.pageid3,
							data:[
								this.resolve_value,
								resolveText,
								summaryText
							],
						}
					}
				).then((res) => {
					this.updateKey++;
					this.resolveDialogueCancel()
				});
			}else if(buttonname == 'Download Files'){
				api.getTroubleticketFileDownload(
					{
						data:{
							pageid:this.pageid2,
							data:[
								this.resolve_value
							],
						}
					}
				).then((res) => {
					if(res.data!=null){
						var fileURL = window.URL.createObjectURL(new Blob([res.data]));
						var fileLink = document.createElement('a');

						fileLink.href = fileURL;
						fileLink.setAttribute('download', 'troubleticket_'+this.resolve_value+'.zip');
						document.body.appendChild(fileLink);

						fileLink.click();
						this.resolveDialogueCancel()
					}
				});
			}
		},

		select(){
			this.file=null;
			this.loading=true;
			this.ready=false;
			this.loadingBarWidth = 0
			var length = this.uploadFiles.length

			var widths = []
			var promises = []

			for(let i = 0;i<length;i++){
				promises.push(new Promise((resolve, reject) => {
					var reader = new FileReader()
					reader.onload = function(e){
						this.files[i] = {imageName:this.uploadFiles[i].name, imageData:e.target.result}
						resolve(null);
					}.bind(this);

					reader.onprogress = function(e){
						if (e.lengthComputable) {
			                widths[i] = parseInt( (((e.loaded / e.total) * 100) / length), 10 );
							this.loadingBarWidth = widths.reduce((a, b) => a + b, 0)
			            }
					}.bind(this);

					reader.onerror = function(e){
						console.log(e)
						this.uploading=false;
						this.loading=false;
						this.ready=false;
						this.uploadFiles = []
						this.files = []

						alert("error: File could not be read")
						reject(null);
					}.bind(this);

					reader.readAsDataURL(this.uploadFiles[i])
		        }));
			}

			Promise.all(promises).then((results) => {
				this.loading=false;
				this.ready=true;
			});
		},
	},
	mounted: function () {
		this.$nextTick(function () {
			this.progressBar = document.getElementById("progress")
			this.loadingBar = document.getElementById("loading-progress")
			this.progressBar.style = "width:0%"
			this.loadingBar.style = "width:0%"
		})
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
}

.textfield{
    width:100%;
	height:150px;
	min-height:75px;
	max-height:375px;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

button.link {
    background:none;
    border:none;
    color:#0066dd;
    text-decoration: underline;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}
td {
    border: none;
}

.upload-box{
    left:12.5%;
	width:75%;
}

.custom-file-input ~ .custom-file-label::after {
  content: 'sh';
}
.unselectable {
	pointer-events:none;
}

</style>



// WEBPACK FOOTER //
// src/components/add/Add_Issues.vue